import React, { useState, useRef } from 'react';
import { Search, Filter, Eye } from 'lucide-react';
import { Link } from 'react-router-dom';
import { FilterDropdown } from '../components/FilterDropdown';
const dreams = [{
  id: 1,
  user: 'Ana Silva',
  dreamName: 'Aprender inglês fluente',
  category: 'Educação',
  goalDate: '31/12/2024',
  steps: 12,
  completedSteps: 8,
  progress: 67
}, {
  id: 2,
  user: 'Carlos Santos',
  dreamName: 'Correr uma maratona',
  category: 'Saúde',
  goalDate: '15/06/2024',
  steps: 20,
  completedSteps: 8,
  progress: 40
}, {
  id: 3,
  user: 'Maria Oliveira',
  dreamName: 'Economizar R$ 10.000',
  category: 'Finanças',
  goalDate: '31/03/2024',
  steps: 10,
  completedSteps: 10,
  progress: 100
}, {
  id: 4,
  user: 'João Pedro',
  dreamName: 'Ler 24 livros este ano',
  category: 'Educação',
  goalDate: '31/12/2024',
  steps: 24,
  completedSteps: 12,
  progress: 50
}, {
  id: 5,
  user: 'Fernanda Costa',
  dreamName: 'Viajar para Paris',
  category: 'Viagens',
  goalDate: '01/08/2024',
  steps: 15,
  completedSteps: 3,
  progress: 20
}, {
  id: 6,
  user: 'Ricardo Alves',
  dreamName: 'Conseguir promoção',
  category: 'Carreira',
  goalDate: '30/09/2024',
  steps: 8,
  completedSteps: 6,
  progress: 75
}];
export function Dreams() {
  const [searchTerm, setSearchTerm] = useState('');
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [categoryFilter, setCategoryFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const [progressFilter, setProgressFilter] = useState({
    min: '',
    max: ''
  });
  const filterButtonRef = useRef<HTMLButtonElement>(null);
  const handleApplyFilters = () => {
    setIsFilterOpen(false);
  };
  const handleClearFilters = () => {
    setCategoryFilter('all');
    setStatusFilter('all');
    setProgressFilter({
      min: '',
      max: ''
    });
  };
  const activeFiltersCount = [categoryFilter !== 'all', statusFilter !== 'all', progressFilter.min || progressFilter.max].filter(Boolean).length;
  return <div className="space-y-6" data-id="element-290">
      <div className="flex items-center justify-between" data-id="element-291">
        <div data-id="element-292">
          <h1 className="text-3xl font-bold text-gray-900" data-id="element-293">Sonhos</h1>
          <p className="text-gray-600 mt-1" data-id="element-294">
            Visualize todos os sonhos cadastrados no aplicativo
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-295">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-296">
          <p className="text-gray-600 text-sm" data-id="element-297">Total de Sonhos</p>
          <p className="text-3xl font-bold text-gray-900 mt-1" data-id="element-298">18.492</p>
        </div>
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-299">
          <p className="text-gray-600 text-sm" data-id="element-300">Sonhos Realizados</p>
          <p className="text-3xl font-bold text-green-600 mt-1" data-id="element-301">6.847</p>
        </div>
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-302">
          <p className="text-gray-600 text-sm" data-id="element-303">Em Andamento</p>
          <p className="text-3xl font-bold text-[#8BC4C3] mt-1" data-id="element-304">9.234</p>
        </div>
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-305">
          <p className="text-gray-600 text-sm" data-id="element-306">Taxa de Conclusão</p>
          <p className="text-3xl font-bold text-[#2C4A6B] mt-1" data-id="element-307">37,0%</p>
        </div>
      </div>
      <div className="bg-white rounded-xl shadow-sm border border-gray-200" data-id="element-308">
        <div className="p-6 border-b border-gray-200" data-id="element-309">
          <div className="flex items-center gap-4" data-id="element-310">
            <div className="flex-1 relative" data-id="element-311">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-312" />
              <input type="text" placeholder="Buscar por sonho ou usuário..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8BC4C3] focus:border-transparent" data-id="element-313" />
            </div>
            <div className="relative" data-id="element-314">
              <button ref={filterButtonRef} onClick={() => setIsFilterOpen(!isFilterOpen)} className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors relative" data-id="element-315">
                <Filter className="w-5 h-5" data-id="element-316" />
                Filtros
                {activeFiltersCount > 0 && <span className="absolute -top-1 -right-1 w-5 h-5 bg-[#8BC4C3] text-white text-xs font-bold rounded-full flex items-center justify-center" data-id="element-317">
                    {activeFiltersCount}
                  </span>}
              </button>
              <FilterDropdown isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)} onApply={handleApplyFilters} onClear={handleClearFilters} triggerRef={filterButtonRef} data-id="element-318">
                <div className="space-y-4" data-id="element-319">
                  <div data-id="element-320">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-321">
                      Categoria
                    </label>
                    <select value={categoryFilter} onChange={e => setCategoryFilter(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8BC4C3] focus:border-transparent" data-id="element-322">
                      <option value="all" data-id="element-323">Todas</option>
                      <option value="Educação" data-id="element-324">Educação</option>
                      <option value="Saúde" data-id="element-325">Saúde</option>
                      <option value="Carreira" data-id="element-326">Carreira</option>
                      <option value="Viagens" data-id="element-327">Viagens</option>
                      <option value="Finanças" data-id="element-328">Finanças</option>
                    </select>
                  </div>
                  <div data-id="element-329">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-330">
                      Status
                    </label>
                    <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8BC4C3] focus:border-transparent" data-id="element-331">
                      <option value="all" data-id="element-332">Todos</option>
                      <option value="completed" data-id="element-333">Concluído</option>
                      <option value="in_progress" data-id="element-334">Em Andamento</option>
                      <option value="planned" data-id="element-335">Planejado</option>
                    </select>
                  </div>
                  <div data-id="element-336">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-337">
                      Progresso (%)
                    </label>
                    <div className="space-y-2" data-id="element-338">
                      <input type="number" placeholder="Mínimo" value={progressFilter.min} onChange={e => setProgressFilter({
                      ...progressFilter,
                      min: e.target.value
                    })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8BC4C3] focus:border-transparent" min="0" max="100" data-id="element-339" />
                      <input type="number" placeholder="Máximo" value={progressFilter.max} onChange={e => setProgressFilter({
                      ...progressFilter,
                      max: e.target.value
                    })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8BC4C3] focus:border-transparent" min="0" max="100" data-id="element-340" />
                    </div>
                  </div>
                </div>
              </FilterDropdown>
            </div>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-341">
          <table className="w-full" data-id="element-342">
            <thead className="bg-gray-50 border-b border-gray-200" data-id="element-343">
              <tr data-id="element-344">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-345">
                  Usuário
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-346">
                  Nome do Sonho
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-347">
                  Categoria
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-348">
                  Data da Meta
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-349">
                  Passos
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-350">
                  Progresso
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-351">
                  Ações
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-352">
              {dreams.map(dream => <tr key={dream.id} className="hover:bg-gray-50 transition-colors" data-id="element-353">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-354">
                    <div className="flex items-center gap-3" data-id="element-355">
                      <div className="w-8 h-8 bg-gradient-to-br from-[#8BC4C3] to-[#2C4A6B] rounded-full flex items-center justify-center text-white text-sm font-semibold" data-id="element-356">
                        {dream.user.charAt(0)}
                      </div>
                      <span className="text-sm font-medium text-gray-900" data-id="element-357">
                        {dream.user}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 font-medium" data-id="element-358">
                    {dream.dreamName}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-359">
                    <span className="px-2 py-1 text-xs font-medium bg-gray-100 text-gray-700 rounded" data-id="element-360">
                      {dream.category}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600" data-id="element-361">
                    {dream.goalDate}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600" data-id="element-362">
                    {dream.completedSteps}/{dream.steps}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-363">
                    <div className="flex items-center gap-2" data-id="element-364">
                      <div className="w-24 bg-gray-200 rounded-full h-2" data-id="element-365">
                        <div className="bg-gradient-to-r from-[#8BC4C3] to-[#2C4A6B] h-2 rounded-full" style={{
                      width: `${dream.progress}%`
                    }} data-id="element-366" />
                      </div>
                      <span className="text-sm font-medium text-gray-900" data-id="element-367">
                        {dream.progress}%
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm" data-id="element-368">
                    <Link to={`/dreams/${dream.id}`} className="p-1.5 text-[#2C4A6B] hover:bg-[#E8F4F4] rounded transition-colors inline-block" title="Visualizar Detalhes" data-id="element-369">
                      <Eye className="w-4 h-4" data-id="element-370" />
                    </Link>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between" data-id="element-371">
          <p className="text-sm text-gray-600" data-id="element-372">
            Mostrando 1 a 6 de 18.492 sonhos
          </p>
          <div className="flex gap-2" data-id="element-373">
            <button className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-374">
              Anterior
            </button>
            <button className="px-3 py-1.5 text-sm bg-[#8BC4C3] text-white rounded-lg" data-id="element-375">
              1
            </button>
            <button className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-376">
              2
            </button>
            <button className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-377">
              3
            </button>
            <button className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-378">
              Próximo
            </button>
          </div>
        </div>
      </div>
    </div>;
}